<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-views has-side-bars">
    <ItemNote v-if="noteText" :text="noteText" />
    <ItemNote :text="views + $t('views_last_year')" />
  </div>
</template>

<script>
import ItemNote from './ItemNote.vue'
/**
 * Display number of views of an Item
 *  @example [none]
 */
export default {
  name: 'ItemViews',
  components: { ItemNote },
  props: {
    views: {
      default: '__',
    },
    noteText: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-views
  padding-bottom: vw(40px)
  padding-top: vw(40px)

  // .mobile &
  // padding-top: vw(20px)
  >>> .item-note
    &:not(:last-child)
      margin-bottom: vw(20px)
</style>
